import React, { useState } from 'react';

const DropdownInput = ({ id="dropdownInput", label, placeholder="", options, value, setValue, ...props }) => {

  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setValue(value);

    const filtered = options.filter(option =>
      option.toLowerCase().includes(value.toLowerCase())
    ).slice(0, 5);
    setFilteredOptions(filtered);
  };

  const handleOptionClick = (option) => {
    setValue(option);
    setFilteredOptions([]);
  };

  const handleBlur = () => {
    if (!options.includes(value)) {
      setValue('');
    }
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  return (
    <div className="dropdown-input" onBlur={handleBlur} onFocus={handleFocus}>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        {...props}
      />
      {isFocused && filteredOptions.length > 0 && (
        <ul className="dropdown-list">
          {filteredOptions.map((option, index) => (
            <li key={index} onMouseDown={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownInput;
